import { render, staticRenderFns } from "./IconImage.vue?vue&type=template&id=0fa0b20c&scoped=true"
import script from "./IconImage.vue?vue&type=script&lang=ts"
export * from "./IconImage.vue?vue&type=script&lang=ts"
import style0 from "./IconImage.vue?vue&type=style&index=0&id=0fa0b20c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa0b20c",
  null
  
)

export default component.exports